import { delay, put } from "redux-saga/effects"
import { storeTimeoutModalIsOpen } from "actions"

// API実行開始後に指定の秒数が経過後、タイムアウト処理を実行する
export function* execTimeoutTimer() {
  yield delay(5000)
  yield put(storeTimeoutModalIsOpen(true))
}
